const sectionMarqueeImageCss = `
[data-type='section-marquee-image'] [data-attribute='card-container'] {
  --marquee-duration: 100s;
  padding: 40px 0;
}

[data-type='section-marquee-image'] .wrap-content {
  overflow: hidden;
}

[data-type='section-marquee-image'] .section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  margin-bottom: 40px;
}

[data-type='section-marquee-image'] .section-header .section-title {
  font-size: 24px;
  font-weight: bold !important;
  margin-bottom: 10px;
}

[data-type='section-marquee-image'] .section-header .line-stroke {
  max-width: 100%;
}

[data-type='section-marquee-image'] .section-header .section-description {
  font-size: 18px;
  margin-top: 10px;
}

[data-type='section-marquee-image'] .marquee-wrapper {
  overflow: hidden;
  width: 100%;
  display: flex;
}

[data-type='section-marquee-image'] .marquee-wrapper:hover .slider-jk {
  animation-play-state: paused;
}

[data-type='section-marquee-image'] .marquee-wrapper .slider-jk {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  animation: marquee2 var(--marquee-duration) linear infinite;
  animation-play-state: running;
  max-width: max-content;
  column-gap: 70px;
}

[data-type='section-marquee-image'] .marquee-wrapper .slider-jk .track {
  flex-shrink: 0;
  width: max-content;
}

[data-type='section-marquee-image'] .marquee-wrapper .slider-jk .wrap-item .wrap-img {
  width: fit-content;
}

[data-type='section-marquee-image'] .marquee-wrapper .slider-jk .wrap-item .wrap-img img {
  display: block;
  height: 120px;
  width: auto;
}

@container (max-width: 1024px) {
  [data-type='section-marquee-image'] .marquee-wrapper .slider-jk {
    column-gap: 40px;
  }
}

@container (max-width: 768px) {
  [data-type='section-marquee-image'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-marquee-image'] .section-header .section-title {
    font-size: 18px;
  }

  [data-type='section-marquee-image'] .section-header .section-description {
    font-size: 14px;
  }

  [data-type='section-marquee-image'] .marquee-wrapper .slider-jk {
    column-gap: 20px;
  }

  [data-type='section-marquee-image'] .marquee-wrapper .slider-jk .wrap-item .wrap-img img {
    height: 80px;
  }
}

@keyframes marquee2 {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
`;
export default sectionMarqueeImageCss;
